module.exports = __webpack_public_path__ + "img/research-group-2.c15cfd87.jpg";